import { createSlice } from '@reduxjs/toolkit'
import { jwtDecode } from 'jwt-decode'
import { authApi } from 'redux/api/auth.api'
import { buyCardApi } from 'redux/api/buy-card.api'
import { lkApi } from 'redux/api/lk.api'
import { otpApi } from 'redux/api/otp.api'
import { PURGE } from 'redux-persist'

import { RootState } from '..'

type InitialState = {
  openModalAfterBuy: boolean
}

const initialState: InitialState = {
  openModalAfterBuy: false
}

const settingsSlice = createSlice({
  name: 'settingsSlice',
  initialState,
  reducers: {
    setOpenModalAfterBuy: (state, { payload }) => {
      state.openModalAfterBuy = payload
    }
  }
})

export const openModalAfterBuySelector = (state: RootState) => state.application.openModalAfterBuy

export const { setOpenModalAfterBuy } = settingsSlice.actions
export default settingsSlice.reducer
